<template>
  <div class="container single_ayah_cont p-0">
    <div
      class="verse"
      :class="[
        !bg
          ? ayah && ayah.ayahNum % 2 == 0
            ? 'ayahBox2 ' + $store.getters.arabicFontStyle
            : 'ayahBox1 ' + $store.getters.arabicFontStyle
          : 'ayahBox2 ' + $store.getters.arabicFontStyle,
      ]"
      v-if="ayah && typeof ayah == 'object'"
    >
      <div>
        <router-link
          :to="surah.surahNum.toString()"
          v-if="bg"
          class="d-flex align-items-center pb-2 px-1 textBlue"
          style="font-size: 14px"
        >
          <span style="font-family: system-ui">
            {{ surah.czechName + " - " }}&#160;
          </span>
          <span>
            {{ " سورة " + surah.arabicName }}
          </span>
          <span style="font-family: system-ui; font-size: 12px; margin-left: 5px;">
            ({{ surah.czechTrans }})
          </span>
        </router-link>
      </div>
      <div class="ayahBoxHeader">
        <a
          class="ayahBoxNum cursor_pointer"
          @click.prevent="singleAyahShow(surah.surahNum, ayah && ayah.ayahNum)"
          >{{ surah && surah.surahNum }}:{{ ayah && ayah.ayahNum }}</a
        >
        <div class="ayahBoxHeaderLinks">
          <a
            class="action_toTop"
            v-if="!ayahNum"
            href=""
            @click.prevent="topUpAction"
            ><span></span>to top</a
          >
          <a class="action_toTop" v-else href="" @click.prevent="goToSurah"
            ><span></span>Go to Surah</a
          >
        </div>
      </div>
      <!-- v-if="
        $store.getters.transCheckBoxSettings[arabicLangId] &&
        $store.getters.transCheckBoxSettings[arabicLangId].checked
      " -->
      <div
        class="ayah arabic_lang"
        style="text-align: right; direction: rtl"
        dir="rtl"
      >
        <!-- <span
          style="font-style: italic;"
          :style="{
            fontSize: $store.getters.customizeFontsSize + 32 + 'px',
          }"
        >
          {{ ayah.fullAyah }}
        </span>
        <br> -->
        <span
          v-for="(word, ind) in ayah.ayahWords"
          :key="ind"
          :data-title="word.translation ? word.translation : word.arabicWord"
          :style="{
            fontSize: $store.getters.customizeFontsSize + 32 + 'px',
          }"
          @click="mouseenter(word)"
          lang="ar"
        >
          <span
            class="verse_word"
            v-if="hightLightText && checkWordIfSearched(word.arabicWord)"
            style="color: #2dce89"
          >
            {{ word.arabicWord }}
          </span>
          <span class="verse_word" v-else>
            {{ word.arabicWord }}
          </span>
        </span>
<!--        <span :data-title="`Verse No. ${ayah.ayahNum}`" class="verse_word">-->
<!--          <span class="ayah_end" lang="arabic" :style="{ fontSize: '40px' }">-->
<!--            {{ ayah && ayah.ayahNum | convertFormat }}-->
<!--          </span>-->
<!--        </span>-->
      </div>
      <div v-if="allowAllTrans">
        <div
          v-for="(language, idx) in languages"
          :key="idx"
          id="verse_1_language_17"
          class="ayah language_17 text"
          v-show="language.name != 'Arabština'"
          style="font-family: Georgia; text-align: left; display: block"
        >
          <div v-if="setLangTranslation(language._id, ayah.ayahTranslations)">
            <div
              class="ayah_translation"
              :style="{
                fontSize: $store.getters.customizeFontsSize + 2 + 'px',
                lineHeight: ($store.getters.customizeFontsSize / 2) * 3 + 'px',
              }"
            >
              {{ language.name }}
            </div>
            <span
              id="verse_1_language_17_content"
              :style="{
                fontSize: $store.getters.customizeFontsSize + 4 + 'px',
                lineHeight: ($store.getters.customizeFontsSize / 2) * 3 + 'px',
              }"
              class="ayah_translation"
              v-html="setLangTranslation(language._id, ayah.ayahTranslations)"
            ></span>
          </div>
        </div>
      </div>
      <div v-else>
        <div
          v-for="(language, idx) in languages"
          :key="idx"
          id="verse_1_language_17"
          class="ayah language_17 text"
          v-show="language.name != 'Arabština'"
          style="font-family: Georgia; text-align: left; display: block"
        >
          <div
            v-if="
              $store.getters.transCheckBoxSettings[arabicLangId] &&
              $store.getters.transCheckBoxSettings[language._id].checked
            "
          >
            <div
              class="ayah_translation"
              :style="{
                fontSize: $store.getters.customizeFontsSize + 2 + 'px',
                lineHeight: ($store.getters.customizeFontsSize / 2) * 3 + 'px',
              }"
            >
              {{ language.name }}
            </div>
            <span
              id="verse_1_language_17_content"
              :style="{
                fontSize: $store.getters.customizeFontsSize + 4 + 'px',
                lineHeight: ($store.getters.customizeFontsSize / 2) * 3 + 'px',
              }"
              class="ayah_translation"
              v-html="setLangTranslation(language._id, ayah.ayahTranslations)"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "@/apiList";

String.prototype.toAr = function () {
  return this.replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d]);
};
export default {
  name: "SingleAyah",
  components: {},
  props: ["surah", "ayah", "bg", "allowAllTrans", "hightLightText"],
  data() {
    return {
      playing: false,
      surahNum: this.$route.params.surahNum,
      ayahNum: this.$route.params.ayahNum || false,

      arabicLangId: JSON.parse(localStorage.getItem("arabicLangId")),
      languages: JSON.parse(localStorage.getItem("languages")),
    };
  },
  methods: {
    topUpAction() {
      this.$emit("scrollToTop");
    },
    singleAyahShow(surahNum, ayahNum) {
      if (!this.ayahNum) {
        this.$router.push({ path: "/" + surahNum + "/" + ayahNum });
      }
    },
    async goToSurah() {
      this.$emit("changeSurah", this.surahNum);
    },
    checkWordIfSearched(ayahWord) {
      let search =
        this.$store.getters.searchSettings.searchKey || this.$route.query.query;
      if (ayahWord.includes(search.trim()) || (search && search.trim().includes(ayahWord)))
        return true;
      return false;
    },
    setLangTranslation: function (langId, ayahTranslations) {
      let search =
        this.$store.getters.searchSettings.searchKey || this.$route.query.query;

      let trans =
        ayahTranslations && ayahTranslations.length
          ? ayahTranslations.find((obj) => obj.translationId == langId)
          : null;
      if (trans) {
        if (search && this.hightLightText && trans.translation) {
          return trans.translation.replace(
            new RegExp(search, "gi"),
            (match) => {
              return (
                '<span class="highlighted" style="color: #2dce89;">' +
                match +
                "</span>"
              );
            }
          );
        }
        return trans.translation;
      }
      return trans;
    },
    mouseenter(arabic_word) {
      if (arabic_word.wordAudio && !this.playing) {
        let audioLink = "https:" + arabic_word.wordAudio;
        let audio = new Audio(audioLink);
        audio.play();
        // console.log(audio.timeUpdate());
      }
    },
  },
  filters: {
    convertFormat: function (number) {
      if (!number) number = 0;
      return String(number).replace(/[0-9]/g, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1728)
      );
    },
  },
  mounted() {
    // console.log(this.languages);
  },
};
</script>
<style lang="scss" scoped>
$global_color: #4c709b;
$global_color_lit: #4c709bcc;

.single_ayah_cont {
  scroll-behavior: smooth !important;
}
.columnMain {
  padding: 0px;
  padding-left: 10px;

  .title {
    height: 25px;
    z-index: 2;
  }

  #quranOutput {
    line-height: normal;
    padding-bottom: 5px;

    a {
      outline: none;
    }

    .ayahBox1 {
      // background-color: #ccffb3;
      background-color: $global_color;
      .ayahBoxNum {
        color: $global_color !important;
        box-shadow: none !important;
      }
      .ayahBoxHeaderLinks {
        a {
          color: #bce874 !important;
        }
      }

      span.verse_word,
      i.verse_word {
        color: rgba(255, 255, 255, 0.9) !important;
        &:hover {
          color: rgb(188, 232, 116) !important;
          border-color: rgb(188, 232, 116) !important;
        }

        span.ayah_end {
          color: #fff !important;
          border: 2px solid #fff !important;

          &:hover {
            color: rgb(188, 232, 116) !important;
            border-color: rgb(188, 232, 116) !important;
            &:before {
              border-color: rgb(188, 232, 116) !important;
            }
          }

          &:before {
            border: 2px solid #fff !important;
            width: 90% !important;
            height: 90% !important;
            border-radius: 100%;
          }
        }
      }

      [data-title]:after {
        box-shadow: none !important;
      }

      div.ayah_translation {
        color: rgb(188, 232, 116) !important;
      }
      span.ayah_translation {
        color: #fff !important;
      }
    }

    .ayahBox1,
    .ayahBox2 {
      padding: 10px 5px 10px 10px;
      // border-bottom: 1px dotted #d4d4d4;
      min-height: 75px;
      margin-bottom: 20px;
    }

    .verse {
      border-radius: 10px;
      margin: 30px 0px 5px 0px;

      .ayahBoxHeader {
        position: absolute;
        line-height: 16px;

        .ayahBoxNum {
          display: block;
          background: #fef2da;
          text-decoration: none;
          color: #d6b169;
          font-size: 20px;
          padding: 10px 8px 6px 8px;
          text-align: center;
          border-radius: 5px;
          box-shadow: 1px 1px 5px rgb(188, 232, 116);
        }
        .ayahBoxHeaderLinks {
          font-size: 12px;
          margin-top: 5px;
          line-height: normal;

          a {
            color: #999;
            font-weight: 600;
            text-decoration: none;
            display: block;
            padding: 1px 0;

            &.action_toTop span {
              background-position: 0 0;
            }
            span {
              display: block;
              float: left;
              width: 11px;
              height: 11px;
              margin: 3px 4px 0 0;
              background: url("../../assets/images/ayah_actions.png") no-repeat
                0 0;
            }
          }
        }
      }
      .ayah {
        margin: 0px 15px 0px 80px;
        padding: 0px 0px 10px 0px;
        line-height: normal;

        &.arabic_lang {
          min-height: 60px;
        }

        div {
          font: italic 16px/18px georgia;
          color: #6798bf;
          display: block;
        }
        span {
          color: #000;

          &.verse_word:hover,
          &.bism:hover {
            cursor: pointer;
            color: #0099ff;
            border-bottom: 2px solid #0099ff;
          }
        }

        i {
          color: #000;

          &.verse_word:hover {
            cursor: pointer;
            color: #0099ff;
            border-bottom: 2px solid #0099ff;
          }
        }

        span.bism,
        span.verse_word {
          font-weight: 300;
          color: rgba(0, 0, 0, 0.9);
          display: inline-block;
          padding-left: 0.75rem;

          span.ayah_end {
            position: relative;
            border: 2px solid black;
            border-radius: 100%;
            padding: 0px 15px 0px 15px;
            display: flex;
            justify-content: center;
            align-items: center;
            &:hover {
              color: #0099ff;
              border-color: #0099ff;

              &:before {
                border-color: #0099ff;
              }
            }

            &:before {
              content: "";
              position: absolute;
              border: 2px solid black;
              display: block;
              width: 92%;
              height: 92%;
              border-radius: 100%;
              top: 2.5px;
              left: 2.5px;
            }
          }

          &:last-child:hover {
            border-bottom: none;
          }
        }

        div.ayah_translation {
          font-size: 16px;
          line-height: 24px;
          color: $global_color;
        }
      }
    }
  }
}
.highlighted {
  color: #0099ff;
}
</style>